export const COLUMNS = {
  SELECT: 'select',
  STATUS: 'reviewStatus.code',
  WARNING: 'warning',
  LOCK: 'lock',
  DATE: 'date',
  CREATION_DATE: 'creation_date',
  USER: 'card.user.firstName',
  MERCHANT: 'merchant',
  AMOUNT: 'amount',
  CARD: 'card',
  CATEGORY: 'category',
  SUBCATEGORY: 'subcategory',
  EXPENSE_DATE: 'expense.date',
  RECEIPT_NUMBER: 'receipt.receiptNumber',
  RECEIPT_PROVIDER: 'receipt.provider',
  RECEIPT_PROVIDER_DATA: 'receipt.providerData',
  BUDGET: 'budget.name',
  RECEIPT: 'receipt',
  OPTIONS: 'options',
  REIMBURSABLE: 'reimbursable',
  NOT_REIMBURSABLE: 'no_reimbursable',
  REVIEWED_DATE: 'reviewedAt',
  TOTAL: 'total',
  PROCESSING_TRANSACTIONS: 'processing_transactions',
  TRANSACTIONS_LIST: [
    {
      key: 'select',
      visible: true,
      modifiable: false,
      template: '20px',
      name: 'empty',
      noHeader: true
    },
    {
      key: 'reviewStatus.code',
      visible: true,
      modifiable: true,
      sortable: true,
      template: 'minmax(100px, 165px)',
      name: 'transactions_charged_table_header_status'
    },
    {
      key: 'warning',
      visible: true,
      modifiable: false,
      template: '30px',
      name: 'empty',
      noHeader: true
    },
    {
      key: 'lock',
      visible: true,
      modifiable: false,
      template: '30px',
      name: 'empty',
      noHeader: true
    },
    {
      key: 'date',
      visible: true,
      modifiable: true,
      sortable: true,
      template: '85px',
      isDate: true,
      name: 'transactions_charged_table_header_date',
      table: ['transactions']
    },
    {
      key: 'creation_date',
      visible: true,
      modifiable: true,
      sortable: true,
      template: '170px',
      name: 'transactions_charged_table_header_creation_date',
      table: ['reimbursements']
    },

    {
      key: 'expense.date',
      isDate: true,
      visible: true,
      modifiable: true,
      sortable: true,
      template: '150px',
      name: 'transactions_charged_table_header_expense_date',
      table: ['reimbursements']
    },
    {
      key: 'card.user.firstName',
      visible: true,
      modifiable: false,
      sortable: true,
      template: 'minmax(150px, 2fr)',
      name: 'transactions_charged_table_header_user'
    },
    {
      key: 'merchant',
      visible: true,
      modifiable: true,
      sortable: true,
      template: 'minmax(130px, 2fr)',
      name: 'transactions_charged_table_header_merchant'
    },
    {
      key: 'amount',
      visible: true,
      modifiable: true,
      sortable: true,
      template: '105px',
      name: 'transactions_charged_table_header_amount'
    },
    {
      key: 'card',
      visible: true,
      modifiable: true,
      sortable: true,
      template: 'minmax(120px, 1.5fr)',
      name: 'transactions_charged_table_header_card',
      filter: 'expense.paymentMethod.officePaymentMethod.name'
    },
    {
      key: 'category',
      visible: true,
      modifiable: true,
      sortable: true,
      template: 'minmax(100px, 120px)',
      name: 'transactions_charged_table_header_category'
    },
    {
      key: 'subcategory',
      visible: true,
      modifiable: true,
      sortable: true,
      template: 'minmax(100px, 120px)',
      name: 'transactions_charged_table_header_subcategory',
      filter: 'subcategory.code'
    },
    {
      key: 'receipt.receiptNumber',
      visible: false,
      modifiable: true,
      sortable: true,
      template: 'minmax(100px, 120px)',
      name: 'transactions_charged_table_header_receipt_number'
    },
    {
      key: 'receipt.provider',
      visible: false,
      modifiable: true,
      sortable: true,
      template: 'minmax(130px,1fr)',
      name: 'transactions_charged_table_header_provider'
    },
    {
      key: 'receipt.providerData',
      visible: false,
      modifiable: true,
      sortable: true,
      template: 'minmax(100px,1fr)',
      name: 'transactions_charged_table_header_provider_data'
    },
    {
      key: 'budget.name',
      visible: true,
      modifiable: true,
      sortable: true,
      template: 'minmax(130px, 1fr)',
      name: 'transactions_charged_table_header_budget'
    },

    {
      key: 'receipt',
      visible: true,
      modifiable: false,
      template: '65px',
      name: 'transactions_charged_table_header_receipt'
    },
    {
      key: 'options',
      visible: true,
      modifiable: false,
      template: '52px',
      noHeader: true
    }
  ],
  EXPORT_LIST: [
    {
      key: 'select',
      visible: true,
      modifiable: false,
      template: '20px',
      name: 'empty',
      noHeader: true
    },
    {
      key: 'reviewStatus.code',
      visible: true,
      modifiable: true,
      sortable: true,
      template: 'minmax(100px, 165px)',
      name: 'transactions_charged_table_header_status'
    },
    {
      key: 'warning',
      visible: true,
      modifiable: false,
      template: '30px',
      name: 'empty',
      noHeader: true
    },
    {
      key: 'lock',
      visible: true,
      modifiable: false,
      template: '30px',
      name: 'empty',
      noHeader: true
    },
    {
      key: 'date',
      visible: true,
      modifiable: true,
      sortable: true,
      template: '85px',
      isDate: true,
      name: 'transactions_charged_table_header_date',
      table: ['transactionsExport']
    },
    {
      key: 'expense.date',
      isDate: true,
      visible: true,
      modifiable: true,
      sortable: true,
      template: '150px',
      name: 'transactions_charged_table_header_expense_date',
      table: ['transactionsExport']
    },
    {
      key: 'reviewedAt',
      isDate: true,
      visible: true,
      modifiable: true,
      sortable: true,
      template: '150px',
      name: 'transactions_charged_table_header_reviewed_date',
      table: ['transactionsExport']
    },
    {
      key: 'card.user.firstName',
      visible: true,
      modifiable: false,
      sortable: true,
      template: 'minmax(150px, 2fr)',
      name: 'transactions_charged_table_header_user'
    },
    {
      key: 'merchant',
      visible: true,
      modifiable: true,
      sortable: true,
      template: 'minmax(130px, 2fr)',
      name: 'transactions_charged_table_header_merchant'
    },
    {
      key: 'amount',
      visible: true,
      modifiable: true,
      sortable: true,
      template: '105px',
      name: 'transactions_charged_table_header_amount'
    },
    {
      key: 'card',
      visible: true,
      modifiable: true,
      sortable: true,
      template: 'minmax(120px, 1.5fr)',
      name: 'transactions_charged_table_header_card',
      filter: 'expense.paymentMethod.officePaymentMethod.name'
    },
    {
      key: 'receipt.receiptNumber',
      visible: false,
      modifiable: true,
      sortable: true,
      template: 'minmax(100px, 120px)',
      name: 'transactions_charged_table_header_receipt_number'
    },
    {
      key: 'receipt.provider',
      visible: false,
      modifiable: true,
      sortable: true,
      template: 'minmax(130px,1fr)',
      name: 'transactions_charged_table_header_provider'
    },
    {
      key: 'receipt.providerData',
      visible: false,
      modifiable: true,
      sortable: true,
      template: 'minmax(100px,1fr)',
      name: 'transactions_charged_table_header_provider_data'
    },
    {
      key: 'budget.name',
      visible: true,
      modifiable: true,
      sortable: true,
      template: 'minmax(130px, 1fr)',
      name: 'transactions_charged_table_header_budget'
    },

    {
      key: 'receipt',
      visible: true,
      modifiable: false,
      template: '65px',
      name: 'transactions_charged_table_header_receipt'
    },
    {
      key: 'options',
      visible: true,
      modifiable: false,
      template: '20px',
      noHeader: true
    }
  ],
  USERS_LIST: [
    {
      key: 'select',
      visible: true,
      modifiable: false,
      template: '25px',
      name: 'empty',
      noHeader: true
    },
    {
      key: 'lock',
      visible: true,
      modifiable: false,
      template: '25px',
      name: 'empty',
      noHeader: true
    },
    {
      key: 'card.user.firstName',
      visible: true,
      modifiable: true,
      template: '300px',
      name: 'transactions_charged_table_header_user'
    },
    {
      key: 'processing_transactions',
      visible: true,
      modifiable: true,
      template: '250px',
      name: 'transactions_charged_table_header_processing_transactions'
    },
    {
      key: 'reimbursable',
      visible: true,
      modifiable: true,
      template: '150px',
      name: 'transactions_charged_table_header_reimbursable'
    },
    {
      key: 'no_reimbursable',
      visible: true,
      modifiable: true,
      template: '170px',
      name: 'transactions_charged_table_header_no_reimbursable'
    },
    {
      key: 'total',
      visible: true,
      modifiable: true,
      template: '100px',
      name: 'transactions_charged_table_header_total'
    },
    {
      key: 'amount',
      visible: true,
      modifiable: true,
      template: '100px',
      name: 'transactions_charged_table_header_amount'
    }
  ]
}
